<template>
    <div class="mine-more">
        <!--    <div class="mine-more" :class="active==1 || active==2 || active==4? 'haveTotal' : ''">-->
        <div class="top">
            <SearchBar @searchHandle="searchHandle"></SearchBar>
            <!--      <EventTotal v-if="active==1 || active==2 || active==4" @tabHandle="tabHandle"></EventTotal>-->
            <DepartmentTab
                ref="DepartmentTab"
                :sources="sources"
                @typeHandle="typeHandle"
                @onClickTab="onClickTab"
            ></DepartmentTab>
        </div>
        <template v-if="sources && sources.length > 0">
            <div class="list" v-if="!emptyShow">
                <template v-if="active == 1 || active == 2 || active == 4">
                    <div v-if="rsv1 == '0'">
                        <ListItem
                            v-for="(item, index) in list"
                            :key="index"
                            :sourceType="sourceTypes[active]"
                            :item="item"
                        ></ListItem>
                    </div>
                    <div v-else>
                        <ExampleItem
                            v-for="(item, index) in listItem"
                            :key="index"
                            :sourceType="sourceTypes[active]"
                            :item="item"
                        ></ExampleItem>
                    </div>
                </template>
                <template v-if="active == 0 || active == 3">
                    <div v-if="rsv1 == '0'">
                        <DraftItem
                            v-for="(item, index) in list"
                            :key="index"
                            :sourceType="sourceTypes[active]"
                            :item="item"
                        ></DraftItem>
                    </div>
                    <div v-else>
                        <ExampleItem
                            v-for="(item, index) in listItem"
                            :key="index"
                            :sourceType="sourceTypes[active]"
                            :item="item"
                        ></ExampleItem>
                    </div>
                </template>
                <p class="recount-wrap" @click="recountClickHandler">
                    <van-icon name="replay" :size="22" />
                    <span class="recount-btn">刷新数据</span>
                </p>
            </div>
            <Error :type="'empty'" v-else></Error>
        </template>
        <template v-else>
            <Error :type="'empty'"></Error>
        </template>
        <ButtomBar :active="active" :rsv1="rsv1" :rsv2="rsv2" @buttomHandle="buttomHandle"></ButtomBar>
        <div class="loading-fixed" v-if="fixedLoading">
            <van-loading type="spinner" />
        </div>
    </div>
</template>

<script>
    import {
        queryEventByType,
        queryStatsList,
        queryReceivedEximplItemList,
        draftsEximplPublicPage,
        querysendGridEximplListNew,
        initiatedEximplPublicPage,
        querysendMyGridEximplPublicPage,
    } from "@/api/MineMore"
    import { Toast, Loading } from "vant"
    import { selectMenuTxtNew } from "../../api/MineMore"
    export default {
        name: "MineMore",
        components: {
            SearchBar: () => import("@/components/MineMore/SearchBar"),
            // EventTotal: () => import('@/components/MineMore/EventTotal'),
            DepartmentTab: () => import("@/components/MineMore/DepartmentTab"),
            ButtomBar: () => import("@/components/MineMore/ButtomBar"),
            ListItem: () => import("@/components/MineMore/ListItem"),
            DraftItem: () => import("@/components/MineMore/DraftItem"),
            ExampleItem: () => import("@/components/MineMore/ExampleItem"),
            [Loading.name]: Loading,
        },
        data() {
            return {
                rsv1: 0,
                rsv2: 0,
                active: 0,
                types: ["todo", "done", "send", "draft", "copy"],
                sourceTypes: [
                    "receivedGridExample",
                    "sendGridEximpl",
                    "initiatedEximpl",
                    "draftsEximpl",
                    "sendMyGridEximpl",
                ],
                sources: [],
                sourcesActive: 0,
                typeActive: 0,
                keyword: "",
                list: [],
                listItem: [],
                emptyShow: false,
                pageSize: 10000,
                pageIndex: 0,
                fixedLoading: true,
            }
        },
        created() {
            this.active = this.$route.query.type
            this.rsv1 = this.$route.query.rsv1
            this.rsv2 = this.$route.query.rsv2
            selectMenuTxtNew(this.sourceTypes[this.active])
                .then(res => {
                    if (res) {
                        this.sources = res
                        this.init()
                    } else {
                        this.$router.push("/empty/empty")
                    }
                })
                .catch(error => {
                    this.$router.push("/empty/empty")
                })
        },
        methods: {
            init() {
                this.fixedLoading = true
                let source_name = this.sourcesActive == 0 ? "" : this.sources[this.sourcesActive].name
                // let category_name =
                //     this.sourcesActive == 0
                //         ? ""
                //         : this.sources[this.sourcesActive].child != null
                //         ? this.sources[this.sourcesActive].child[this.typeActive].name
                //         : ""
                let query_type = this.types[this.active]
                let params = {
                    query_type: query_type ? query_type : "",
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                    // category_code:
                    //     this.sources[this.sourcesActive].child != null
                    //         ? this.sources[this.sourcesActive].child[this.typeActive].id
                    //         : "",
                    item_name: this.keyword ? this.keyword : "",
                    source_code: this.sources[this.sourcesActive] ? this.sources[this.sourcesActive].id : "",
                    source_name: this.sources[this.sourcesActive] ? this.sources[this.sourcesActive].name : "",
                }

                if (this.rsv1 == "false" || this.rsv1 == "0") {
                    queryStatsList(params)
                        .then(resp => {
                            if (resp.data) {
                                this.list = resp.data
                                this.total = resp.total
                                if (!resp.total) {
                                    this.emptyShow = true
                                } else {
                                    this.emptyShow = false
                                }
                                this.fixedLoading = false
                            } else {
                                this.fixedLoading = false
                                if (this.list && this.listItem.length == 0) {
                                    this.emptyShow = true
                                }
                            }
                        })
                        .catch(error => {
                            this.fixedLoading = false
                            this.$router.push("/empty/error")
                        })
                        .finally(() => {
                            this.fixedLoading = false
                        })
                } else {
                    let sourceType = this.sourceTypes[this.active]
                    switch (sourceType) {
                        case "receivedGridExample":
                            this.queryReceivedEximplItemList(params)
                            break
                        case "sendGridEximpl":
                            this.querysendGridEximplListNew(params)
                            break
                        case "initiatedEximpl":
                            this.initiatedEximplPublicPage(params)
                            break
                        case "draftsEximpl":
                            this.draftsEximplPublicPage(params)
                            break
                        case "sendMyGridEximpl":
                            this.querysendMyGridEximplPublicPage(params)
                            break
                    }
                }
            },

            queryReceivedEximplItemList(params) {
                queryReceivedEximplItemList(params)
                    .then(resp => {
                        if (resp.data) {
                            this.listItem = resp.data
                            this.total = resp.total
                            if (!resp.total) {
                                this.emptyShow = true
                            } else {
                                this.emptyShow = false
                            }
                            this.fixedLoading = false
                        } else {
                            this.fixedLoading = false
                            if (this.listItem && this.listItem.length == 0) {
                                this.emptyShow = true
                            }
                        }
                    })
                    .catch(error => {
                        this.fixedLoading = false
                        this.$router.push("/empty/error")
                    })
                    .finally(() => {
                        this.fixedLoading = false
                    })
            },
            draftsEximplPublicPage(params) {
                draftsEximplPublicPage(params)
                    .then(resp => {
                        if (resp.data) {
                            this.listItem = resp.data
                            this.total = resp.total
                            if (!resp.total) {
                                this.emptyShow = true
                            } else {
                                this.emptyShow = false
                            }
                            this.fixedLoading = false
                        } else {
                            this.fixedLoading = false
                            if (this.listItem && this.listItem.length == 0) {
                                this.emptyShow = true
                            }
                        }
                    })
                    .catch(error => {
                        this.fixedLoading = false
                        this.$router.push("/empty/error")
                    })
                    .finally(() => {
                        this.fixedLoading = false
                    })
            },
            querysendGridEximplListNew(params) {
                querysendGridEximplListNew(params)
                    .then(resp => {
                        if (resp.data) {
                            this.listItem = resp.data
                            this.total = resp.total
                            if (!resp.total) {
                                this.emptyShow = true
                            } else {
                                this.emptyShow = false
                            }
                            this.fixedLoading = false
                        } else {
                            this.fixedLoading = false
                            if (this.listItem && this.listItem.length == 0) {
                                this.emptyShow = true
                            }
                        }
                    })
                    .catch(error => {
                        this.fixedLoading = false
                        this.$router.push("/empty/error")
                    })
                    .finally(() => {
                        this.fixedLoading = false
                    })
            },
            initiatedEximplPublicPage(params) {
                initiatedEximplPublicPage(params)
                    .then(resp => {
                        if (resp.data) {
                            this.listItem = resp.data
                            this.total = resp.total
                            if (!resp.total) {
                                this.emptyShow = true
                            } else {
                                this.emptyShow = false
                            }
                            this.fixedLoading = false
                        } else {
                            this.fixedLoading = false
                            if (this.listItem && this.listItem.length == 0) {
                                this.emptyShow = true
                            }
                        }
                    })
                    .catch(error => {
                        this.fixedLoading = false
                        this.$router.push("/empty/error")
                    })
                    .finally(() => {
                        this.fixedLoading = false
                    })
            },
            querysendMyGridEximplPublicPage(params) {
                querysendMyGridEximplPublicPage(params)
                    .then(resp => {
                        if (resp.data) {
                            this.listItem = resp.data
                            this.total = resp.total
                            if (!resp.total) {
                                this.emptyShow = true
                            } else {
                                this.emptyShow = false
                            }
                            this.fixedLoading = false
                        } else {
                            this.fixedLoading = false
                            if (this.listItem && this.listItem.length == 0) {
                                this.emptyShow = true
                            }
                        }
                    })
                    .catch(error => {
                        this.fixedLoading = false
                        this.$router.push("/empty/error")
                    })
                    .finally(() => {
                        this.fixedLoading = false
                    })
            },

            searchHandle(keyword) {
                this.fixedLoading = true
                this.keyword = keyword
                this.list = []
                this.init()
            },
            tabHandle(index) {
                this.fixedLoading = true
                this.emptyShow = false
                this.list = []
                this.sourcesActive = index
                this.init()
            },
            onClickTab(index) {
                this.fixedLoading = true
                this.emptyShow = false
                this.pageIndex = 0
                this.total = 0
                this.list = []
                this.sourcesActive = index
                this.$refs.DepartmentTab.resetTypeActive()
                this.typeActive = 0
                this.typeHandle(this.typeActive)
            },
            typeHandle(idx, name) {
                this.fixedLoading = true
                this.emptyShow = false
                this.list = []
                this.typeActive = idx
                this.init()
            },
            buttomHandle(index, num, rsv2) {
                if (index != this.active) {
                    this.fixedLoading = true
                    this.list = []
                    this.emptyShow = false
                    this.active = index
                    this.sourcesActive = 0
                    this.typeActive = 0
                    this.$refs.DepartmentTab.resetActive()
                    this.$refs.DepartmentTab.resetTypeActive()
                    selectMenuTxtNew(this.sourceTypes[this.active]).then(res => {
                        this.sources = res
                        if (num == 1) {
                            this.$router.push("/MineMore?type=" + index + "&rsv1=" + num + "&rsv2=" + rsv2)
                        } else {
                            this.$router.push("/MineMore?type=" + index + "&rsv1=" + num + "&rsv2=" + rsv2)
                        }
                        // this.$router.push("/MineMore?type=" + index)
                        // window.location.reload()
                        this.init()
                    })
                }
            },
            recountClickHandler() {
                this.init()
                /*Toast.loading({
        message: '正在重算...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 3000,
        onClose: () => this.init()
      })*/
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/css/theme/theme.scss";
    .mine-more {
        padding: 100px 0 65px;
        &.hasType {
            padding-top: 155px;
        }
        &.haveTotal {
            padding-top: 210px;
        }
        .top {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 10001;
            background: #fff;
        }
    }
    .recount-wrap {
        padding: 10px 15px;
        font-size: 14px;
        color: #666;
        display: flex;
        align-items: center;
        justify-content: center;
        @extend .font14;
    }
    .loading-fixed {
        background: rgba(0, 0, 0, 0.6);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10002;
        .van-loading {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
</style>
